module.exports = __webpack_public_path__ + "/fonts/lato-bold.woff";


//////////////////
// WEBPACK FOOTER
// ../components/node_modules/lato-font/fonts/lato-bold/lato-bold.woff
// module id = 224
// module chunks = 0